import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Period, Profile } from '@app/shared';


@Component({
    selector: 'app-no-shifts-list',
    templateUrl: './no-shifts-list.component.html',
    styleUrls: ['./no-shifts-list.component.css']
})
export class NoShiftsListComponent implements OnInit {

    period: Period;
    users: Profile[] = [];

    constructor(
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.route.data.subscribe(
            data => {
                this.period = data.period;
                this.users = data.users;
            }
        );
    }

    get wishListLink() {
        return '/planning/' + this.period.id + '/wish-check-list';
    }

    get noWishesListLink() {
        return '/planning/' + this.period.id + '/no-wishes-list';
    }

    get periodOverviewLink() {
        return '/planning/' + this.period.id;
    }

}
